import React from 'react'

import { connect } from 'react-redux'
import Operations from '../../../../../operations'
import Selectors from '../../../../../selectors'

import {
  EmarModuleCard,
  FamilyPlanModuleCard,
  PaywallTemplate,
} from '@lmc/ui-kit'
import { colors } from '@lmc/common/constants'
import { IconType } from '@lmc/ui-kit'
import { colours } from '@lmc/ui-kit/src/config/theme'
import { HomeSource } from '@lmc/ts-common'

interface StateProps {
  subscribeTo: () => void
  getSubscriptions: () => void
  subscriptionCancelled: boolean
  role: string
  source?: HomeSource
}

const RiskAssessmentPaywallComponent: React.FC<StateProps> = ({
  subscribeTo,
  getSubscriptions,
  subscriptionCancelled,
  role,
  source,
}) => {
  React.useEffect(() => {
    getSubscriptions()
  }, [])

  const ctaDisabled = role === 'senior-carer' || subscriptionCancelled
  let disabledText
  if (subscriptionCancelled) {
    disabledText = 'Note: Sorry, you have already completed a free trial.'
  } else if (role === 'senior-carer') {
    disabledText = 'Note: Only admins can start a free trial.'
  }

  return (
    <PaywallTemplate
      backgroundColor={colours.status.popout}
      title="Risk assessments"
      subTitle="Mitigate risks and protect service users and carers from harm. Choose from over 40 common templates or create your own. You’ll spot high-risk situations in seconds with our auto-generated risk score."
      bodyText="Evidence safe and effective care."
      cta="Start Free Trial"
      onClick={subscribeTo}
      icon={IconType.CarePlansHexagon}
      videoUrl="https://www.youtube.com/embed/SqXLg3_2COw"
      articles={[
        {
          title: 'How do I add a risk assessment?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/collections/1943707-care-plans-and-assessments-module',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white,
        },
        {
          title: 'What is the risk assessment dashboard?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/articles/3371486-risk-assessment-dashboard',
          iconBackgroundColour: colors.green,
          iconColour: colors.white,
        },
        {
          title: 'What other features do I get with Pro?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white,
        },
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={<FamilyPlanModuleCard />}
      ctaDisabled={ctaDisabled}
      disabledText={disabledText}
      findOutMoreURL="https://logmycare.co.uk/features/care-delivery"
      customLinkText="Read more"
      source={source}
    />
  )
}

const mapStateToProps = (state: any) => ({
  subscriptionCancelled: Selectors.isSubscriptionCancelled(
    state,
    'pro-monthly'
  ),
  role: state.global?.user?.role,
  source: state.global?.home?.source,
})

const mapDispatchToProps = (dispatch: any) => ({
  subscribeTo: () =>
    dispatch(
      Operations.openNewPlan({
        planId: 'pro-monthly',
      })
    ),
  getSubscriptions: () => dispatch(Operations.getSubscriptions()),
})

export const RiskAssessmentPaywall = connect(
  mapStateToProps,
  mapDispatchToProps
)(RiskAssessmentPaywallComponent)
